<div [id]="panelId" class="toolbarBase editable hover">
	<div class="toolbar" [id]="toolbarId"></div>
	<div #editordiv [id]="editorId()" class="stages_description" contenteditable="true" [attr.aria-label]="'process.description.action.edit' | translate"></div>
	@if ((isTextCreatorConfigured$ | async) && !!prompts && prompts.length > 0 && (isEditorAvailable$ | async)) {
		<stages-ai-floating-menu
			[selectedText]="(selectedHtml$ | async)!"
			[prompts]="prompts"
			[beanType]="beanType()"
			(updatedText$)="updateEditorContent($event)"
		></stages-ai-floating-menu>
	}
</div>

@if ((isTextCreatorConfigured$ | async) && !!prompts && prompts.length > 0) {
	<div class="info">
		<stages-disclaimer-main [hideALittle]="true" [message]="'ai.general.legal'"></stages-disclaimer-main>
	</div>
}
